export const FETCH_COMPANIES_REQUEST = "FETCH_COMPANIES_REQUEST"
export const FETCH_COMPANIES_SUCCESS = "FETCH_COMPANIES_SUCCESS"
export const FETCH_COMPANIES_FAILED = "FETCH_COMPANIES_FAILED"

export const UPDATE_COMPANY_REQUEST = "UPDATE_COMPANY_REQUEST"
export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS"
export const UPDATE_COMPANY_FAILED = "UPDATE_COMPANY_FAILED"

export const UPDATE_COMPANY_NOTIFICATIONS_REQUEST = "UPDATE_COMPANY_NOTIFICATIONS_REQUEST"
export const UPDATE_COMPANY_NOTIFICATIONS_SUCCESS = "UPDATE_COMPANY_NOTIFICATIONS_SUCCESS"
export const UPDATE_COMPANY_NOTIFICATIONS_FAILED = "UPDATE_COMPANY_NOTIFICATIONS_FAILED"

export const GET_COMPANY_NOTIFICATIONS_REQUEST = "GET_COMPANY_NOTIFICATIONS_REQUEST"
export const GET_COMPANY_NOTIFICATIONS_SUCCESS = "GET_COMPANY_NOTIFICATIONS_SUCCESS"
export const GET_COMPANY_NOTIFICATIONS_FAILED = "GET_COMPANY_NOTIFICATIONS_FAILED"

export const CREATE_COMPANY_REQUEST = "CREATE_COMPANY_REQUEST"
export const CREATE_COMPANY_SUCCESS = "CREATE_COMPANY_SUCCESS"
export const CREATE_COMPANY_FAILED = "CREATE_COMPANY_FAILED"

export const FETCH_COMPANIES_LIST_BY_ROLE_REQUEST = "FETCH_COMPANIES_LIST_BY_ROLE_REQUEST"
export const FETCH_COMPANIES_LIST_BY_ROLE_SUCCESS = "FETCH_COMPANIES_LIST_BY_ROLE_SUCCESS"
export const FETCH_COMPANIES_LIST_BY_ROLE_FAILED = "FETCH_COMPANIES_LIST_BY_ROLE_FAILED"

export const FETCH_COMPANY_PEOPLE_REQUEST = "FETCH_COMPANY_PEOPLE_REQUEST"
export const FETCH_COMPANY_PEOPLE_SUCCESS = "FETCH_COMPANY_PEOPLE_SUCCESS"
export const FETCH_COMPANY_PEOPLE_FAILED = "FETCH_COMPANY_PEOPLE_FAILED"